#Всплывающее окно с подтверждением отправки обращения
class window.Gratitude
  constructor: ->
    self = this
    @scroll_top = 0 # размер прокрутки документа
    @$gratitudeBlock = $('.gratitude-block') # само всплывающие окно
    @gratitudeBlockOpenClass = 'gratitude-block--active' # Класс для появления всплывающего окна
    @gratitudeBlockOpen = false # флаг который показывает, открыто ли всплывающие окно

    # закрытие всплывающего окна при клике вне его
    $('.gratitude-block').click (event) ->
      if self.gratitudeBlockOpen
        if $(event.target).closest('.gratitude-block__container').length
          return

        window.shading.shadingDisable(['header'])
        $('html').removeClass('body-overflow')

        $('.gratitude-block').removeClass(self.gratitudeBlockOpenClass)
        self.gratitudeBlockOpen = false
        event.stopPropagation()

    @initGratitudeButtons()
    @initResetForm()

  # инициализируем кнопки, работающие со всплывающим окном
  initGratitudeButtons: ->
    self = this
    window.shadingContent = ['header']

    $('.js-open-gratitude-button').click ->
      window.shading.shadingActive(window.shadingContent)
      $('html').addClass('body-overflow')
      $('.gratitude-block').addClass(self.gratitudeBlockOpenClass)
      self.gratitudeBlockOpen = true

    $('.button-close-block').click ->
      window.shading.shadingDisable(window.shadingContent)

      $('.gratitude-block').removeClass(self.gratitudeBlockOpenClass)
      self.gratitudeBlockOpen = false
      $('html').removeClass('body-overflow')


  # Если мы хотим написать ещё одно обращение
  initResetForm: ->
    self = this

    $('.js-button-new-treatment').click ->
      window.shading.shadingDisable(['header'])

      $('.gratitude-block').removeClass(self.gratitudeBlockOpenClass)
      self.gratitudeBlockOpen = false
      $('html').removeClass('body-overflow')

      $('html, body').animate {scrollTop: $('.base-form-block').offset().top - 72}, 1000

      # Сбрасываем значения полей
      $('.file-name').remove()
      $('input[type="text"]:not([readonly])').val('')
      $('textarea').val('')
      $('select').each ->
        $(this).prop('selectedIndex', 0);
#        $(this).selectmenu('refresh');

      $('.virtual-reception__method_email, #form_checkbox_SIMPLE_QUESTION_433_1').prop('checked', true);

#      $('.js-treatment-reset-block').find('input').each ->
#        $(this).val('');
#
#      $('.js-treatment-reset-block').find('select').each ->
#        $(this).prop('selectedIndex', 0);
#        $(this).selectmenu('refresh');
#
#      $('.js-treatment-reset-block').find('textarea').each ->
#        $(this).val('');


// WEBPACK FOOTER //
// ./assets/javascripts/app/gratitude_block.coffee